import sx from '@styled-system/css';
import { jsx } from '@theme-ui/core';
import Button, { ButtonProps, Ghost, Link } from './components/button';
import Input, { InputProps } from './components/input';
import Selectable from './components/selectable';
import View, { ViewProps } from './components/view';
import Text, { styles as textVariants, TextProps } from './components/text';
import { Logo, Lockup } from './components/branding';
import styled from './components/styled';
import ThemeProvider, { Theme, useTheme, theme } from './components/theme';

export {
  Button,
  ButtonProps,
  Ghost as GhostButton,
  Input,
  InputProps,
  Link as LinkButton,
  Lockup,
  Logo,
  Selectable,
  Text,
  TextProps,
  Theme,
  ThemeProvider as Monterey,
  ThemeProvider,
  View,
  ViewProps,
  jsx,
  styled,
  sx,
  textVariants,
  theme,
  useTheme,
};
